import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexGroup',
  setup(__props) {

const basicGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/basicGroup.vue"))
const edgesGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/edgesGroup.vue"))
const flatGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/flatGroup.vue"))
const largeGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/largeGroup.vue"))
const largeEdges = defineAsyncComponent(() => import("@/components/theme/buttons/group/largeEdges.vue"))
const outlineGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineGroup.vue"))
const outlineCustom = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineCustom.vue"))
const outlineButton = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineButton.vue"))
const outlineEdges = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineEdges.vue"))
const outlineFlat = defineAsyncComponent(() => import("@/components/theme/buttons/group/outlineFlat.vue"))
const radioButton = defineAsyncComponent(() => import("@/components/theme/buttons/group/radioButton.vue"))
const checkboxButton = defineAsyncComponent(() => import("@/components/theme/buttons/group/checkboxButton.vue"))
const nestingGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/nestingGroup.vue"))
const verticalGroup = defineAsyncComponent(() => import("@/components/theme/buttons/group/verticalGroup.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Buttons",
      title: "Button Group"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicGroup)),
        _createVNode(_unref(edgesGroup)),
        _createVNode(_unref(flatGroup)),
        _createVNode(_unref(largeGroup)),
        _createVNode(_unref(largeEdges)),
        _createVNode(_unref(outlineGroup)),
        _createVNode(_unref(outlineCustom)),
        _createVNode(_unref(outlineButton)),
        _createVNode(_unref(outlineEdges)),
        _createVNode(_unref(outlineFlat)),
        _createVNode(_unref(radioButton)),
        _createVNode(_unref(checkboxButton)),
        _createVNode(_unref(nestingGroup)),
        _createVNode(_unref(verticalGroup))
      ])
    ])
  ], 64))
}
}

})